import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie, Doughnut } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend)

const hexToRGB = (hex) => {
  let alpha = false,
    h = hex.slice(hex.startsWith('#') ? 1 : 0)
  if (h.length === 3) h = [...h].map((x) => x + x).join('')
  else if (h.length === 8) alpha = true
  h = parseInt(h, 16)
  return (
    'rgb' +
    (alpha ? 'a' : '') +
    '(' +
    (h >>> (alpha ? 24 : 16)) +
    ', ' +
    ((h & (alpha ? 0x00ff0000 : 0x00ff00)) >>> (alpha ? 16 : 8)) +
    ', ' +
    ((h & (alpha ? 0x0000ff00 : 0x0000ff)) >>> (alpha ? 8 : 0)) +
    (alpha ? `, ${h & 0x000000ff}` : '') +
    ')'
  )
}

function Graph({ list = [], className }) {
  const data = {
    data: list.map((item) => item.value),
    backgroundColor: list.map(({ color }) => (color.startsWith('rgb(') ? color : hexToRGB(color))),
    datalabels: {
      // align: 'end',
      anchor: 'center',
      formatter: (value) => {
        return value + '%'
      },
    },
  }
  return (
    <div className={className} style={{ backgroundColor: '#ffffff' }}>
      <Pie
        data={{ datasets: [data] }}
        options={{
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          rotation: -90,
          circumference: 180,
        }}
      />
    </div>
  )
}

export default Graph
